'use client'
import {useState} from "react";
import styles from '@/app/styles/components/input/number-input.module.scss'

const NumberInput = ({defaultValue = 1, onClick}) => {
    const [number, setNumber] = useState(defaultValue)

    const handlePlus = () => {
        setNumber(number + 1);
        onClick(number + 1)
    };

    const handleMinus = () => {
        if (number - 1 === 0) {
            return;
        }
        setNumber(number- 1);
        onClick(number - 1)
    };

    return <div className={styles.numberInputContainer}>
        <span onClick={() => handleMinus()} className={styles.control}>-</span>
        <span className={styles.number}>{number}</span>
        <span onClick={() => handlePlus()} className={styles.control}>+</span>
    </div>
}

export default NumberInput